var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('span',{staticClass:"icon"},[_c('icon',{attrs:{"id":"circle-info"}})],1),_c('span',{staticClass:"text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }